import React from 'react'

export const tennesseeSetupVars = {
  siteId: 'tennessee',
  pathPrefix: '/tn',
  menuHeader: "Discover Tennessee's Solution for:",
  appUrl: 'https://tn.headed2.com',
  logoImg: '/images/assets/tennessee/horizontal/dark.svg',
  headerTitle: `The Tennessee CareerExplorer is a system designed for Tennessee`
}
